var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pa-6"},[_c('div',{staticClass:"d-flex justify-end mb-4"},[_c('StudentReportExcelExport')],1),_c('StudentReportTable')],1)}
var staticRenderFns = []

export { render, staticRenderFns }